<div class="ds-dialog">
  <div class="ds-header">
    <div class="ds-title-wrap">
      <div class="ds-title-icon"><mat-icon>query_stats</mat-icon></div>
      <div><h2 class="ds-title">Data submissions</h2><div class="ds-subtitle">Record and review measurements for this event</div></div>
    </div>
    <button mat-icon-button class="ds-close" (click)="close()" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>
  <div class="ds-body">
    <div class="ds-toolbar">
      <span>{{dataSubmissionDisplays.length}} submission{{dataSubmissionDisplays.length === 1 ? '' : 's'}}</span>
      <button type="button" class="ds-add" (click)="add()" [disabled]="!canAddSubmission"><mat-icon>add</mat-icon>Add submission</button>
    </div>
  <div class="row">
    <div class="col-12">
      <p-table class="data-sub-table" [value]="dataSubmissionDisplays" responsiveLayout="default" dataKey="id" editMode="row" [tableStyle]="{'min-width': '50rem', 'border-collapse': 'separate'}">
        <ng-template pTemplate="header">
          <tr>
            <th>User</th>
            @for (def of dataCollectionDefinitions; track def) {
              <th>
                {{def.name}} @if (getUnitViewModel(def.unit).suffix != null) {
                <span>({{getUnitViewModel(def.unit).suffix}})</span>
              }
            </th>
          }
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-submission let-ri="rowIndex">
        <tr [pEditableRow]="submission" [className]="getClass(submission)">
          <td class="table-cell">
            <!-- <p-cellEditor> -->
            @if (submission.editing) {
              <app-user-select
                [(userId)]="submission.dataSubmission.userId"
                [includeNullValue]="true"
                (userIdChange)="userChange($event)">
              </app-user-select>
              <!-- //[excludedUserIds]="currentSelectedUserIds" -->
              <!-- <p-dropdown
              [options]="users"
              appendTo="body"
              [(ngModel)]="submission.dataSubmission.userId"
              optionLabel="displayName"
            [style]="{'width':'100%'}"></p-dropdown> -->
          }
          @if (!submission.editing) {
            {{getSelectedUsersName(submission.dataSubmission.userId)}}
          }
        <!-- </p-cellEditor> -->
      </td>
      @for (def of dataCollectionDefinitions; track def) {
        <td class="table-cell">
          <!-- <p-cellEditor> -->
          @if (submission.editing) {
            @if (getUnitViewModel(def.unit).inputType == 'text') {
              <mat-form-field appearance="outline" class="table-editor">
                <input matInput type="text" [(ngModel)]="submission.dataSubmission.data[def.id]" />
                @if (getUnitViewModel(def.unit).suffix != null) {
                  <span matSuffix>{{getUnitViewModel(def.unit).suffix}}</span>
                }
              </mat-form-field>
            }
            @if (getUnitViewModel(def.unit).inputType == 'number') {
              <mat-form-field appearance="outline" class="table-editor">
                <input matInput type="number" [(ngModel)]="submission.dataSubmission.data[def.id]" />
                @if (getUnitViewModel(def.unit).suffix != null) {
                  <span matSuffix>{{getUnitViewModel(def.unit).suffix}}</span>
                }
                @if (getUnitViewModel(def.unit).sumMultiple) {
                  <button mat-icon-button matSuffix class="mat-suffix-add" (click)="increment(submission, def)">
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </mat-form-field>
            }
            @if (getUnitViewModel(def.unit).inputType == 'date') {
              <mat-form-field appearance="outline" class="table-editor">
                <!-- <input matInput type="text" [placeholder]="def.name" [(ngModel)]="submission.dataSubmission.data[def.id]" />
                <span matSuffix *ngIf="def.unit.suffix != null">{{def.unit.suffix}}</span> -->
                <input matInput [matDatepicker]="datePicker" [(ngModel)]="submission.dataSubmission.data[def.id]"
                  disabled="true" class="workflow-start-date">
                <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                <mat-datepicker #datePicker disabled="false"></mat-datepicker>
              </mat-form-field>
            }
            @if (getUnitViewModel(def.unit).inputType == 'time') {
              <app-time-input
                [setCurrentTimeOnClick]="true"
                [(time)]="submission.dataSubmission.data[def.id]">
              </app-time-input>
            }
            <!-- <input
            pInputText type="text"
            [(ngModel)]="submission.dataSubmission.data[def.id]" /> -->
          }
          @if (!submission.editing) {
            {{submission.dataSubmission.data[def.id]}}
            <!-- {{product.price | currency: 'USD'}} -->
          }
        <!-- </p-cellEditor> -->
      </td>
    }
    <td class="table-cell" style="min-width: 110px;">
      <div class="flex align-items-center justify-content-center gap-2">
        @if (!submission.editing) {
          <button
            pButton
            pRipple
            type="button"
            pInitEditableRow
            icon="pi pi-pencil"
            (click)="onRowEditInit(submission)"
            class="p-button-rounded p-button-text">
          </button>
        }
        @if (!submission.editing) {
          <button
            pButton
            pRipple
            type="button"
            pInitEditableRow
            icon="pi pi-trash"
            (click)="onRowDelete(submission)"
            class="p-button-rounded p-button-text">
          </button>
        }
        @if (submission.editing) {
          <button
            pButton
            pRipple
            type="button"
            pSaveEditableRow
            icon="pi pi-check"
            (click)="onRowEditSave(submission)"
            class="p-button-rounded p-button-text p-button-success mr-2">
          </button>
        }
        @if (submission.editing) {
          <button
            pButton pRipple
            type="button"
            pCancelEditableRow
            icon="pi pi-times"
            (click)="onRowEditCancel(submission, ri)"
            class="p-button-rounded p-button-text p-button-danger">
          </button>
        }
      </div>
    </td>
  </tr>
</ng-template>
</p-table>
</div>
</div>
  </div>
  <div class="ds-footer">
    <span>Finish any active row edit before saving</span>
    <div><button mat-button class="ds-btn-ghost" (click)="close()">Cancel</button><button type="button" class="ds-btn-primary" (click)="save()"><span>Save submissions</span><mat-icon>check</mat-icon></button></div>
  </div>
</div>
